import React from "react";
import { CheckIcon } from "lucide-react";
import { finalIncluded } from "../../data/content";
import { CtaButton } from "../ui/CtaButton";
import { Countdown } from "../ui/Countdown";
export function FinalCta() {
  return <section className="bg-brand-900 px-5 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-139" data-mp="1no6puo7aayxj">
      <div className="mx-auto max-w-3xl text-center" data-id="element-140" data-mp="1sn17hmtimhg2">
        <h2 id="final-title" className="font-serif text-[2rem] font-black leading-[1.12] text-white sm:text-5xl" data-id="element-141" data-mp="1eob820j845oj">
          Are you ready to stop searching through <em className="italic text-brand-300" data-id="element-142" data-mp="1iqogwxt9ojpj">scattered resources?</em>
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-brand-100" data-id="element-143" data-mp="14r5gysam0eob">
          Start studying and practicing with one visual system designed to help you find what you need when you need it.
        </p>
      </div>

      <ul className="mx-auto mt-8 grid max-w-2xl grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-144" data-mp="2z5g3uv7n8yrg">
        {finalIncluded.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white/10 px-4 py-3 text-[17px] font-bold uppercase tracking-wide text-white" data-id="element-145" data-mp="341583bulz3u3">
            <CheckIcon className="h-5 w-5 shrink-0 text-brand-300" strokeWidth={3} aria-hidden="true" data-id="element-146" data-mp="3ted158yeybtk" />
            {item}
          </li>)}
      </ul>

      <div className="mx-auto mt-8 max-w-2xl text-center" data-id="element-147" data-mp="b39lce52j72f">
        <p className="text-lg text-brand-100" data-id="element-148" data-mp="70d68xeqlt38">All inside one complete system.</p>
        <p className="mt-4 font-serif text-3xl font-black text-white" data-id="element-149" data-mp="3fgogo289d6p1">Reflexology 360°™</p>
        <p className="mt-2 text-lg leading-relaxed text-brand-100" data-id="element-150" data-mp="3ahbvrn0y69p3">
          Organize your study. Reference your maps. Follow structured sequences. Practice with greater clarity.
        </p>
        <p className="mt-6 text-base font-bold uppercase tracking-widest text-brand-300" data-id="element-151" data-mp="3jgqj4dlti45d">Just</p>
        <p className="font-serif text-7xl font-black leading-none text-white" data-id="element-152" data-mp="13pkre4bg206m">$27</p>
      </div>

      <div className="mx-auto mt-8 max-w-xl" data-id="element-153" data-mp="yriy6qkb0khf">
        <CtaButton label="Yes! I want my Reflexology 360°" data-id="element-154" data-mp="yqrdwbw5q96g" />
        <p className="mt-3 text-center text-sm text-brand-100" data-id="element-155" data-mp="3sjsewzr07e6a">
          One-time payment · Instant Digital Access · Lifetime Access · 7-Day Guarantee
        </p>
        <Countdown dark data-id="element-156" data-mp="1eistj64rk1y" />
        <p className="mt-5 text-center text-base text-brand-100" data-id="element-157" data-mp="5drqv087e43b">
          Get REFLEXOLOGY 360°™ today and receive <strong className="text-white" data-id="element-158" data-mp="admfex4iahl7">all 5 bonuses FREE.</strong>
        </p>
      </div>
    </section>;
}